<div class="split-container">
    <div class="left-panel" [ngStyle]="{ width: leftWidth + 'px' }">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            (refreshDataFromServer)="refreshData($event)" (rowSelected)="emitQuestionData($event)" #gridComponent
            [gridName]="gridName" (addClicked)="addQuestion()" (deleteClicked)="deleteQuestion()"
            (exportClicked)="exportQuestionsClicked()">
        </app-grid>
    </div>

    <div class="splitter" (mousedown)="startDragging($event)"></div>

    <div class="right-panel">
        <app-create-questions class="question-container" [selectedQuestion]="selectedQuestion">
        </app-create-questions>
    </div>
</div>